import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "windows",
  "use": "windows-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" fill=\"currentColor\" id=\"windows\">\n    <path d=\"M.007 8.4L0 2.549l7.2-.978V8.4H.007zM8.4 1.397L17.998 0v8.4H8.4V1.397zM18 9.6l-.002 8.4L8.4 16.65V9.6H18zM7.2 16.497L.006 15.51V9.6H7.2v6.897z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol